export const SET_ACCESS_TOKEN = "SET_ACCESS_TOKEN";
export const SET_ACCESS_USER_TYPE = "SET_ACCESS_USER_TYPE";
export const SET_MY_INFO = "SET_MY_INFO";
export const DESTROY_ACCESS_TOKEN = "DESTROY_ACCESS_TOKEN";
export const DESTROY_MY_INFO = "DESTROY_MY_INFO";

export const SET_USER_INFO = "SET_USER_INFO";
export const SET_KAKAO_ACCOUNT = "SET_KAKAO_ACCOUNT";
export const DESTROY_KAKAO_ACCOUNT = "DESTROY_KAKAO_ACCOUNT";
export const SET_TEST = "SET_TEST";